import { FC } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * Props for the LoadingNode component
 */
interface LoadingNodeProps {
  /** Message to display while loading */
  message?: string;
}

/**
 * LoadingNode component displays a loading indicator with an optional message
 * while tree nodes are being loaded.
 */
export const LoadingNode: FC<LoadingNodeProps> = ({ message = 'Loading...' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        p: 1,
        pl: 3, // Match TreeItem indentation
      }}
    >
      <CircularProgress size={16} />
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
    </Box>
  );
};
